import React from 'react';
import NumberTypePage from './NumberTypePage';

const UIFNNumbers = () => <NumberTypePage type="uifn" />;

export default UIFNNumbers;
